/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ===== WaBo-Design · JS-Sprachwörterbuch (custom.js ist statisch -> liest <html lang>) ===== */
window.wabotr = window.wabotr || function(k){
  var l = (document.documentElement.lang || 'de').slice(0,2).toLowerCase();
  if(l!=='en' && l!=='fr' && l!=='it') l='de';
  var D = {
    card_view:{de:'Ansehen & berechnen',en:'View & calculate',fr:'Voir & calculer',it:'Vedi & calcola'},
    calc_eg:{de:'Beispiel: 5 m × 4 m = 20 m² – die passende Paketzahl rechnen wir automatisch.',en:'Example: 5 m × 4 m = 20 m² – we calculate the number of packs automatically.',fr:'Exemple : 5 m × 4 m = 20 m² – nous calculons le nombre de paquets automatiquement.',it:'Esempio: 5 m × 4 m = 20 m² – calcoliamo automaticamente il numero di confezioni.'},
    c_title:{de:'Jetzt Bedarf berechnen',en:'Calculate your needs',fr:'Calculez votre besoin',it:'Calcola il fabbisogno'},
    c_len:{de:'Raumlänge in Metern',en:'Room length in metres',fr:'Longueur de la pièce en mètres',it:'Lunghezza della stanza in metri'},
    c_wid:{de:'Raumbreite in Metern',en:'Room width in metres',fr:'Largeur de la pièce en mètres',it:'Larghezza della stanza in metri'},
    c_area:{de:'Fläche (in m²)',en:'Area (in m²)',fr:'Surface (en m²)',it:'Superficie (in m²)'},
    c_wastage:{de:'+ 5% mehr Produkt für Verschnitt einberechnen',en:'+ add 5% extra for cutting waste',fr:'+ ajouter 5 % pour les chutes',it:'+ aggiungi il 5% per lo sfrido'},
    c_total:{de:'Gesamtpreis:',en:'Total price:',fr:'Prix total :',it:'Prezzo totale:'},
    c_pack:{de:'1 Paket =',en:'1 pack =',fr:'1 paquet =',it:'1 confezione ='},
    c_packprice:{de:'Paketpreis',en:'Pack price',fr:'Prix du paquet',it:'Prezzo confezione'},
    c_equals:{de:'entspricht',en:'equals',fr:'soit',it:'pari a'},
    eta_label:{de:'Lieferung zwischen {start} und {end}',en:'Delivery between {start} and {end}',fr:'Livraison entre le {start} et le {end}',it:'Consegna tra il {start} e il {end}'},
    t1:{de:'Gratis-Versand ab {FS}',en:'Free shipping from {FS}',fr:'Livraison gratuite dès {FS}',it:'Spedizione gratuita da {FS}'},
    t2:{de:'Muster bestellen, Kosten werden beim Bodenkauf voll erstattet',en:'Order a sample, cost fully credited when you buy the floor',fr:'Commandez un échantillon, montant entièrement déduit à l’achat du sol',it:'Ordina un campione, importo interamente accreditato all’acquisto del pavimento'},
    t3:{de:'Fachbetrieb seit 2008',en:'Specialist since 2008',fr:'Spécialiste depuis 2008',it:'Specialisti dal 2008'},
    t4:{de:'Kauf auf Rechnung (Klarna & PayPal)',en:'Buy on account (Klarna & PayPal)',fr:'Achat sur facture (Klarna & PayPal)',it:'Acquisto su fattura (Klarna & PayPal)'},
    t5:{de:'Schnelle Lieferung per Spedition',en:'Fast delivery by freight forwarder',fr:'Livraison rapide par transporteur',it:'Consegna rapida con corriere'},
    t6:{de:'14 Tage Rückgaberecht',en:'14-day return policy',fr:'14 jours de rétractation',it:'14 giorni di reso'},
    faq_title:{de:'Häufige Fragen zu diesem Boden',en:'Frequently asked questions about this floor',fr:'Questions fréquentes sur ce sol',it:'Domande frequenti su questo pavimento'},
    faq_q1:{de:'Ist dieser Boden für Fußbodenheizung geeignet?',en:'Is this floor suitable for underfloor heating?',fr:'Ce sol convient-il au chauffage au sol ?',it:'Questo pavimento è adatto al riscaldamento a pavimento?'},
    faq_a1:{de:'Die meisten unserer Vinylböden sind für Warmwasser-Fußbodenheizung geeignet – Klebevinyl leitet die Wärme besonders gut. Die genaue Eignung findest du in den Produktdetails. Im Zweifel beraten wir dich gern persönlich.',en:'Most of our vinyl floors are suitable for warm-water underfloor heating – glue-down vinyl conducts heat particularly well. You’ll find the exact suitability in the product details. When in doubt, we’re happy to advise you personally.',fr:'La plupart de nos sols vinyle conviennent au chauffage au sol à eau chaude – le vinyle à coller conduit particulièrement bien la chaleur. La compatibilité exacte figure dans les détails du produit. En cas de doute, nous vous conseillons volontiers.',it:'La maggior parte dei nostri pavimenti in vinile è adatta al riscaldamento a pavimento ad acqua – il vinile da incollare conduce molto bene il calore. L’idoneità esatta è indicata nei dettagli del prodotto. In caso di dubbi, ti consigliamo volentieri di persona.'},
    faq_q2:{de:'Klicken oder Kleben – was passt zu mir?',en:'Click or glue – which suits me?',fr:'Clipsable ou à coller – que choisir ?',it:'Click o da incollare – quale fa per me?'},
    faq_a2:{de:'Klickvinyl verlegst du schwimmend und ohne Kleber – ideal für Heimwerker und zur Miete. Klebevinyl wird vollflächig verklebt, ist besonders robust und top bei Fußbodenheizung und großen Flächen.',en:'Click vinyl is installed floating and without glue – ideal for DIY and rented homes. Glue-down vinyl is fully bonded, especially robust and great for underfloor heating and large areas.',fr:'Le vinyle clipsable se pose flottant et sans colle – idéal pour les bricoleurs et en location. Le vinyle à coller est collé en plein, particulièrement robuste et parfait pour le chauffage au sol et les grandes surfaces.',it:'Il vinile a click si posa flottante e senza colla – ideale per il fai-da-te e in affitto. Il vinile da incollare è incollato a tutta superficie, particolarmente robusto e ottimo per il riscaldamento a pavimento e le grandi superfici.'},
    faq_q3:{de:'Wie viel Boden muss ich bestellen?',en:'How much floor do I need to order?',fr:'Quelle quantité de sol dois-je commander ?',it:'Quanto pavimento devo ordinare?'},
    faq_a3:{de:'Nutze den Flächenrechner auf dieser Seite: Raumlänge × Breite eingeben, optional 5 % Verschnitt dazu – die passende Paketzahl wird automatisch in die Menge übernommen. Tipp: Lieber ein Paket mehr als zu wenig.',en:'Use the area calculator on this page: enter room length × width, optionally add 5% for cutting waste – the right number of packs is added to the quantity automatically. Tip: better one pack too many than too few.',fr:'Utilisez le calculateur de surface sur cette page : saisissez longueur × largeur de la pièce, ajoutez en option 5 % de chute – le nombre de paquets adéquat est repris automatiquement dans la quantité. Astuce : mieux vaut un paquet de trop que pas assez.',it:'Usa il calcolatore di superficie in questa pagina: inserisci lunghezza × larghezza della stanza, aggiungi facoltativamente il 5% di sfrido – il numero giusto di confezioni viene inserito automaticamente nella quantità. Consiglio: meglio una confezione in più che in meno.'},
    faq_q4:{de:'Wie lange dauert die Lieferung?',en:'How long does delivery take?',fr:'Combien de temps prend la livraison ?',it:'Quanto tempo richiede la consegna?'},
    faq_a4:{de:'In der Regel ca. 7–10 Werktage per Spedition. Ab {FS} Bestellwert liefern wir versandkostenfrei.',en:'Usually approx. 7–10 working days by freight forwarder. From {FS} order value we deliver free of shipping costs.',fr:'En général env. 7 à 10 jours ouvrés par transporteur. À partir de {FS} de commande, la livraison est gratuite.',it:'Di solito circa 7–10 giorni lavorativi con corriere. Da {FS} di valore dell’ordine la consegna è gratuita.'},
    faq_q5:{de:'Kann ich vorher ein Muster bekommen?',en:'Can I get a sample first?',fr:'Puis-je recevoir un échantillon d’abord ?',it:'Posso ricevere prima un campione?'},
    faq_a5:{de:'Ja! Bestell dieses Dekor über den Button „Muster bestellen“ ganz einfach nach Hause (19,95 € für bis zu 3 Böden). Beim Kauf des Bodens erstatten wir dir die Musterkosten.',en:'Yes! Order this décor to your home via the “Order a sample” button (€19.95 for up to 3 floors). When you buy the floor, we refund the sample cost.',fr:'Oui ! Commandez ce décor chez vous via le bouton « Commander un échantillon » (19,95 € pour jusqu’à 3 sols). À l’achat du sol, nous vous remboursons le coût de l’échantillon.',it:'Sì! Ordina questo decoro a casa tramite il pulsante «Ordina un campione» (19,95 € per fino a 3 pavimenti). All’acquisto del pavimento ti rimborsiamo il costo del campione.'}
  };
  return (D[k] && D[k][l]) || (D[k] && D[k].de) || k;
};

/* ===== WaBo-Design · Muster-Logik: liegt jetzt zentral in snippets/wabo-sample-engine.liquid
   (Property-Modell "Muster 1..3", geladen über wabo-redesign.liquid). Hier bewusst KEIN
   waboAddSample / .wabo-mini-Binding mehr, sonst Doppel-Handler. ===== */

/* ===== WaBo-Design · Boden-Kacheln: blinden Quick-Add -> Produktseite lenken ===== */
;(function(){
  function fix(root){
    (root || document).querySelectorAll('.product-item').forEach(function(card){
      if(card.dataset.waboFixed) return;
      if(!card.querySelector('.wabo-mini')) return;            // nur Boeden (Mini-Button = Boden)
      var btn = card.querySelector('[data-action="add-to-cart"]');
      if(!btn){ card.dataset.waboFixed = '1'; return; }        // Mehrvariant ist bereits ein Link
      var lnk = card.querySelector('a.product-item__title') || card.querySelector('a.product-item__image-wrapper');
      var url = lnk ? lnk.getAttribute('href') : null;
      if(!url){ card.dataset.waboFixed = '1'; return; }
      var a = document.createElement('a');
      a.href = url;
      a.className = btn.className;
      a.textContent = wabotr('card_view');
      btn.parentNode.replaceChild(a, btn);
      card.dataset.waboFixed = '1';
    });
  }
  function init(){
    fix(document);
    if('MutationObserver' in window){
      var t;
      new MutationObserver(function(muts){
        for(var i=0;i<muts.length;i++){
          if(muts[i].addedNodes && muts[i].addedNodes.length){ clearTimeout(t); t = setTimeout(function(){ fix(document); }, 60); break; }
        }
      }).observe(document.body, { childList:true, subtree:true });
    }
  }
  // Flash vermeiden: Add-to-Cart auf Boden-Kacheln ausblenden, bis JS umbaut
  try{
    var hs = document.createElement('style');
    hs.textContent = '.product-item:has(.wabo-mini) [data-action="add-to-cart"]{visibility:hidden}';
    (document.head || document.documentElement).appendChild(hs);
  }catch(e){}
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* ===== WaBo-Design · SEO: doppelte H1 entschaerfen (FAQ-Separatoren H1 -> H2) ===== */
;(function(){
  function fixFaqHeadings(){
    var list = document.querySelectorAll('h1.faq__group-title');
    for(var i=0;i<list.length;i++){
      var h1 = list[i];
      var h2 = document.createElement('h2');
      for(var a=0;a<h1.attributes.length;a++){ h2.setAttribute(h1.attributes[a].name, h1.attributes[a].value); }
      h2.innerHTML = h1.innerHTML;
      h1.parentNode.replaceChild(h2, h1);
    }
  }
  if(document.readyState !== 'loading') fixFaqHeadings(); else document.addEventListener('DOMContentLoaded', fixFaqHeadings);
})();

/* ===== WaBo-Design · Live-Suche: Styles fuer Quicklinks + No-Results ===== */
;(function(){
  var s = document.createElement('style');
  s.textContent = '.wabo-srch-quick{display:flex;gap:8px;flex-wrap:wrap;border-top:1px solid #e6ebf1;margin-top:10px;padding-top:12px}.wabo-srch-quick__link{flex:1 1 160px;text-align:center;padding:10px 12px;border:1px solid #cfdcea;border-radius:8px;font-size:13.5px;font-weight:600;color:#2769ad;text-decoration:none;background:#fff;transition:background .15s,border-color .15s}.wabo-srch-quick__link:hover{background:#f1f7fd;border-color:#3280cc}.wabo-srch-empty{padding:4px 0}.wabo-srch-help{margin-top:12px;padding:12px 14px;background:#f6fafe;border:1px solid #d6e6f6;border-radius:10px;text-align:center}.wabo-srch-help__txt{margin:0 0 6px;font-size:14px;color:#3c4855}.wabo-srch-help__call{display:inline-block;font-size:15px;font-weight:700;color:#3280cc;text-decoration:none}.wabo-srch-help__call:hover{color:#2769ad}';
  (document.head || document.documentElement).appendChild(s);
})();

/* ===== WaBo-Design · Bedarfsrechner: inputmode=decimal + Beispiel-Hinweis (Mobile-UX) ===== */
;(function(){
  function calcEnhance(){
    ['.sqm-length', '.sqm-width', '#area'].forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){ el.setAttribute('inputmode', 'decimal'); });
    });
    (function(){
      var l=(document.documentElement.lang||'de').slice(0,2).toLowerCase();
      if(l!=='en'&&l!=='fr'&&l!=='it') return;
      var set=function(sel,k){ var e=document.querySelector(sel); if(e) e.textContent=wabotr(k); };
      set('.calculator--header h2','c_title');
      var rl=document.querySelectorAll('.calculator .room-label'); if(rl[0]) rl[0].textContent=wabotr('c_len'); if(rl[1]) rl[1].textContent=wabotr('c_wid');
      set('.calculator .area-label','c_area');
      set('.calculator label[for="wastage-option"]','c_wastage');
      var ip=document.querySelector('.calculator > p');
      if(ip && ip.innerHTML.indexOf('Paketpreis')!==-1){ ip.innerHTML = ip.innerHTML.replace('📦 1 Paket =', wabotr('c_pack')).replace('Paketpreis', wabotr('c_packprice')).replace('entspricht', wabotr('c_equals')); }
      var tp=document.querySelector('.total-price--text');
      if(tp){ for(var i=0;i<tp.childNodes.length;i++){ var n=tp.childNodes[i]; if(n.nodeType===3 && n.nodeValue.indexOf('Gesamtpreis')!==-1){ n.nodeValue=wabotr('c_total')+' '; break; } } }
    })();
    var sqm = document.querySelector('.sqm-calculator');
    if(sqm && !document.querySelector('.wabo-calc-eg')){
      var p = document.createElement('p');
      p.className = 'wabo-calc-eg';
      p.textContent = wabotr('calc_eg');
      sqm.parentNode.insertBefore(p, sqm);
    }
    if(!document.getElementById('wabo-calc-eg-style')){
      var st = document.createElement('style'); st.id = 'wabo-calc-eg-style';
      st.textContent = '.wabo-calc-eg{margin:0 0 14px;padding:9px 12px;background:#fff;border:1px dashed #cfdcea;border-radius:8px;font-size:13px;line-height:1.45;color:#3c4855}';
      (document.head || document.documentElement).appendChild(st);
    }
  }
  if(document.readyState !== 'loading') calcEnhance(); else document.addEventListener('DOMContentLoaded', calcEnhance);
})();


/* ===== WaBo-Design · Custom-Liquid-Bloecke (Vorteile + FAQ) uebersetzen (lang != de) ===== */
;(function(){
  function localizeBlocks(){
    var FS = window.WABO_FS || null;
    var l=(document.documentElement.lang||'de').slice(0,2).toLowerCase();
    var tl=document.querySelectorAll('.wabo-trust__list li');
    var items=document.querySelectorAll('.wabo-faq__item');
    if(l==='en'||l==='fr'||l==='it'){
      ['t2','t3','t5'].forEach(function(k,i){ if(tl[i]){ tl[i].textContent=wabotr(k); } });
      var ft=document.querySelector('.wabo-faq__title'); if(ft) ft.textContent=wabotr('faq_title');
      for(var i=0;i<items.length && i<5;i++){
        var sm=items[i].querySelector('summary'); if(sm) sm.textContent=wabotr('faq_q'+(i+1));
        var a=items[i].querySelector('.wabo-faq__a'); if(a){ var av=wabotr('faq_a'+(i+1)); if(FS) av=av.replace('{FS}',FS); a.textContent=av; }
      }
    } else if(FS){
      if(items[3]){ var a4=items[3].querySelector('.wabo-faq__a'); if(a4) a4.textContent = a4.textContent.replace(/1\.000\s*€/g, FS); }
    }
  }
  if(document.readyState!=='loading') localizeBlocks(); else document.addEventListener('DOMContentLoaded', localizeBlocks);
})();

/* ===== WaBo-Design · Lieferzeit-Schätzung (markt-abhängig, ersetzt Lieferzeit-App) ===== */
;(function(){
  function addBiz(date, n){ var d=new Date(date.getTime()), a=0; while(a<n){ d.setDate(d.getDate()+1); var w=d.getDay(); if(w!==0&&w!==6) a++; } return d; }
  var LOC={de:'de-DE',en:'en-GB',fr:'fr-FR',it:'it-IT'};
  function fillEta(){
    var el=document.querySelector('.wabo-eta');
    if(!el || el.dataset.done) return;
    var CC=window.WABO_CC||'DE';
    var min,max; if(CC==='DE'){min=7;max=10;}else{min=10;max=14;}
    var now=new Date(), wd=now.getDay(), isBiz=(wd!==0&&wd!==6);
    var orderDay=(isBiz && now.getHours()<12) ? now : addBiz(now,1);
    var earliest=addBiz(orderDay,min), latest=addBiz(orderDay,max);
    var l=(document.documentElement.lang||'de').slice(0,2).toLowerCase(); if(l!=='en'&&l!=='fr'&&l!=='it') l='de';
    var loc=LOC[l], opt={weekday:'short',day:'numeric',month:'long'};
    var s=earliest.toLocaleDateString(loc,opt), e=latest.toLocaleDateString(loc,opt);
    var tpl=wabotr('eta_label').replace('{start}','<strong>'+s+'</strong>').replace('{end}','<strong>'+e+'</strong>');
    el.innerHTML='<span class="wabo-eta__dot"></span><span>'+tpl+'</span>';
    el.dataset.done='1';
    el.hidden=false;
  }
  function init(){
    if(!document.getElementById('wabo-eta-style')){
      var st=document.createElement('style'); st.id='wabo-eta-style';
      st.textContent='.wabo-eta{display:flex;align-items:center;gap:9px;margin:10px 0 0;padding:9px 12px;background:#f0faf3;border:1px solid #cfe9d8;border-radius:8px;font-size:13.5px;line-height:1.4;color:#16263a}.wabo-eta strong{color:#1c7d4d;font-weight:700}.wabo-eta__dot{flex:none;width:9px;height:9px;border-radius:50%;background:#1c9d55;box-shadow:0 0 0 3px rgba(28,157,85,.18)}';
      (document.head||document.documentElement).appendChild(st);
    }
    fillEta();
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('variant:changed', function(){ setTimeout(init, 60); });
})();

/* ===== WaBo-Design · Event-Tracking (GA4): Rechner, Boden-Finder, Angebots-CTA ===== */
;(function(){
  function track(name, params){
    params = params || {};
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch(e){}
    try { window.dataLayer = window.dataLayer || []; var o={event:name}; for(var k in params){ if(Object.prototype.hasOwnProperty.call(params,k)) o[k]=params[k]; } window.dataLayer.push(o); } catch(e){}
  }
  window.waboTrack = window.waboTrack || track;

  var calcSent=false, finderSent=false;

  // Klicks: Angebots-CTA + Boden-Finder-Start (Event-Delegation)
  document.addEventListener('click', function(e){
    var el = e.target;
    if(!el || !el.closest) return;
    if(el.closest('[data-quote-open]')){ track('angebot_cta_klick', { cta:'grosses_projekt', seite: location.pathname }); }
    if(!finderSent && el.closest('#wq-start, #wabo-quiz .wq-opt')){ finderSent=true; track('bodenfinder_genutzt', { seite: location.pathname }); }
  }, true);

  // Bedarfsrechner: erste Eingabe zählt als genutzt
  function calcHit(){ if(calcSent) return; calcSent=true; track('bedarfsrechner_genutzt', { seite: location.pathname }); }
  function calcMatch(el){ return el && el.matches && el.matches('.sqm-length, .sqm-width, #area'); }
  document.addEventListener('input', function(e){ if(calcMatch(e.target)) calcHit(); }, true);
  document.addEventListener('change', function(e){ if(calcMatch(e.target)) calcHit(); }, true);
})();


/* ===== WaBo-Design · Versandkosten-Transparenz (PDP, markt-bewusst, kompakt: eine Zeile + aufklappbare Staffel) ===== */
;(function(){
  function money(n){ return n.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}).replace(/,00$/,'')+' €'; }
  function parsePrice(t){ if(!t) return NaN; t=String(t).replace(/[^0-9.,]/g,'').replace(/\.(?=[0-9]{3}(?:[.,]|$))/g,'').replace(',', '.'); return parseFloat(t); }
  function fsAmount(){ var v=parsePrice(window.WABO_FS||''); return isNaN(v)?1000:v; }
  function buildOnce(){
    var eta=document.querySelector('.wabo-eta'); if(!eta) return null;           // nur Böden
    var box=document.querySelector('.wabo-ship-info'); if(box) return box;
    if(!document.getElementById('wabo-ship-style')){
      var st=document.createElement('style'); st.id='wabo-ship-style';
      st.textContent='.wabo-ship-info{margin:8px 0 0;padding:11px 14px;background:#f6fafe;border:1px solid #d6e6f6;border-radius:10px;font-size:13.5px;line-height:1.5;color:#16263a}'
        +'.wabo-ship-info__head{display:flex;align-items:flex-start;gap:9px}'
        +'.wabo-ship-info__ic{flex:none;font-size:1.05rem;line-height:1.2}'
        +'.wabo-ship-info__main b{color:#16263a}'
        +'.wabo-ship-info details{margin-top:7px;border-top:1px solid #e3edf7;padding-top:7px}'
        +'.wabo-ship-info summary{cursor:pointer;list-style:none;color:#2769ad;font-weight:600;font-size:13px}'
        +'.wabo-ship-info summary::-webkit-details-marker{display:none}'
        +'.wabo-ship-info summary::after{content:" ›";transition:transform .15s;display:inline-block}'
        +'.wabo-ship-info details[open] summary::after{transform:rotate(90deg)}'
        +'.wabo-ship-info__tbl{margin:8px 0 0;width:100%;border-collapse:collapse;font-size:12.5px}'
        +'.wabo-ship-info__tbl td{padding:4px 0;border-bottom:1px solid #eef3f8;color:#3c4855}'
        +'.wabo-ship-info__tbl td:last-child{text-align:right;font-weight:600;color:#16263a;white-space:nowrap}'
        +'.wabo-ship-info__tbl .g{color:#1c7d4d!important;font-weight:700}'
        +'.wabo-ship-info__note{margin-top:7px;font-size:12px;color:#6b7785}';
      (document.head||document.documentElement).appendChild(st);
    }
    box=document.createElement('div'); box.className='wabo-ship-info';
    eta.parentNode.insertBefore(box, eta.nextSibling);
    return box;
  }
  function render(){
    var box=buildOnce(); if(!box) return;
    var CC=window.WABO_CC||'DE', FS=fsAmount(), de=(CC==='DE');
    var head='<div class="wabo-ship-info__head"><span class="wabo-ship-info__ic">🚚</span><div class="wabo-ship-info__main">'
      +'<b>Versandkostenfrei ab '+money(FS)+'</b>'+(de?' · darunter ab 30 €':' · Auslandsversand per Spedition')
      +'</div></div>';
    var det='';
    if(de){
      det='<details><summary>Alle Versandkosten ansehen</summary>'
        +'<table class="wabo-ship-info__tbl">'
        +'<tr><td>Muster (bis 29,95 €)</td><td class="g">gratis</td></tr>'
        +'<tr><td>29,95 – 299,99 €</td><td>30 €</td></tr>'
        +'<tr><td>300 – 499,99 €</td><td>50 €</td></tr>'
        +'<tr><td>500 – 999,99 €</td><td>80 €</td></tr>'
        +'<tr><td>ab 1.000 €</td><td class="g">gratis</td></tr>'
        +'</table>'
        +'<p class="wabo-ship-info__note">Gilt für den gesamten Warenkorb. Lieferung per Spedition (frei Bordsteinkante), inkl. MwSt.</p></details>';
    } else {
      det='<p class="wabo-ship-info__note" style="margin-top:7px">Lieferung per Spedition. Versandkosten werden im Checkout berechnet, ab '+money(FS)+' versandkostenfrei.</p>';
    }
    box.innerHTML=head+det;
  }
  function bind(){
    document.addEventListener('variant:changed', function(){ setTimeout(render,80); });
  }
  function init(){ render(); bind(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();